'use client'
import { useEffect, useState } from 'react'
import { DEFAULT_COUNTRY, type CountryCode } from '@/lib/utils/phone'

let cached: CountryCode | null = null
let inflight: Promise<CountryCode> | null = null

async function fetchCountry(): Promise<CountryCode> {
  if (cached) return cached
  inflight ??= fetch('/api/geo').then(r => r.ok ? r.json() : { country: DEFAULT_COUNTRY })
    .then(j => (cached = (j.country as CountryCode) || DEFAULT_COUNTRY))
    .catch(() => (cached = DEFAULT_COUNTRY))
  return inflight
}

export function useDefaultCountry(): CountryCode {
  const [country, setCountry] = useState<CountryCode>(cached ?? DEFAULT_COUNTRY)
  useEffect(() => {
    let alive = true
    fetchCountry().then(c => { if (alive) setCountry(c) })
    return () => { alive = false }
  }, [])
  return country
}
